
import React from 'react';
import TasksFeature from '../features/tasks/Tasks';

const TasksPage: React.FC = () => {
    return <TasksFeature />;
};

export default TasksPage;
